// extracted by mini-css-extract-plugin
export default {"teste":"Dash_teste__78tl3","porc":"Dash_porc__Tq58p","info":"Dash_info__Q4DjB"};